export default __webpack_public_path__ + "static/media/square_crop.bd9c9831.jpg";